
const faltaGridConfig = {
  idField: "idFalta",
  //serviceMethod: "getAtivos",
  columns: [
    { header: "Data", field: "DATA" },
    { header: "Horário", field: "HORARIO", 
      formatter: (value) => value !== null && value !== undefined
        ? `${(value).slice(0,5)} h` : "-"
    },
    { header: "Cliente", field: "NOME" },
    { header: "Ativo", field: "ATIVO",
      formatter: (value) => (value ? "Sim" : "Não")
    }
  ]
};

export default faltaGridConfig;